import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import {Fancybox, Carousel} from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';
import noUiSlider from 'nouislider';
import {easepick} from "@easepick/core";
import {AmpPlugin} from "@easepick/amp-plugin";
import {post} from "./utils";
import initOlMaps from "./map";
import faqHandler from "./faq";
import togglePropertyPageDescription from "./property-page";
import setPhoneMask from "./mask";
import { validateForm } from "./tippy";

// AlpineJS
window.Alpine = Alpine;
Alpine.plugin(collapse);
document.addEventListener('alpine:init', () => {
  // Favorites.
  Alpine.data('favorite', (isFavorite = false, url = '') => ({
    isLiked: isFavorite,
    async toggle() {
      const res = await post(url);
      this.isLiked = res.ok ? res.is_favorite : false;
    }
  }));

  Alpine.data('dropdown', () => ({
    open: false,
    placeholder: '',
    items: {},
    toggle() {
      this.open = !this.open;
    },
  }));

  Alpine.data('tabs', (active = null) => ({
    active,
    toggle() {
      this.open = !this.open;
    },
  }));
});
Alpine.start();

// Mobile menu
const mobMenuItems = document.getElementsByClassName('footer-up-title');
for (var i = 0; i < mobMenuItems.length; i++) {
  mobMenuItems[i].addEventListener('click', (event) => {
    if (window.innerWidth <= 992) {

      event.target.classList.toggle('footer-up-title-active');
      let ul = event.target.parentElement.getElementsByTagName('ul');
      if (ul[0].style.display === "grid") {
        ul[0].style.display = "none";
      } else {
        ul[0].style.display = "grid";
      }
    }
  });
}

// Fancybox.
Fancybox.bind("[data-fancybox]", {
  closeButton: "top",

  Image: {
    click: "close",
    wheel: "slide",
    zoom: false,
    fit: "contain",
  },
  //
  // Thumbs: {
  //   minScreenHeight: 0,
  // },
});
const carouselElements = document.querySelectorAll(".carousel");
carouselElements.forEach((el) => {
  new Carousel(el, {
    // Options
    friction: 0.8,
  });
});

// NoUISlider
window.noUiSlider = noUiSlider
const sliderElements = document.querySelectorAll(".range-slider");
const scales = {
  'THB': {
    'min': [5],
    'max': [1000],
  },
  'RUB': {
    'min': [5],
    'max': [1000],
  },
  'USD': {
    'min': [0],
    'max': [30],
  },
  'EUR': {
    'min': [0],
    'max': [30],
  },
  'GBP': {
    'min': [0],
    'max': [30],
  },
};
sliderElements.forEach((el) => {
  noUiSlider.create(el, {
    start: [el.dataset.min || 0, el.dataset.max || 1000],
    connect: true,
    step: 1,
    range: scales[el.dataset.scale],
    format: {
      from: (value) => value < 1 ? parseFloat(value).toFixed(1) : parseInt(value),
      to: (value) => value < 1 ? parseFloat(value).toFixed(1) : parseInt(value),
    }
  });
  el.noUiSlider.on('update', function (values, handle) {
    el.dispatchEvent(new CustomEvent('update', {bubbles: true, detail: values}));
  });
});

// easepick
const dateEl = document.getElementById('datepicker');
if (dateEl) {
  const lang = dateEl.dataset.lang || 'en';
  new easepick.create({
    element: dateEl,
    css: [
      "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css"
    ],
    zIndex: 10,
    readonly: false,
    inline: true,
    lang,
    AmpPlugin: {
      resetButton: true,
      darkMode: false
    },
    plugins: [AmpPlugin]
  });
}

// Custom.
initOlMaps();

document.addEventListener('DOMContentLoaded', () => {
  // Faq on property pages
  faqHandler();

  // Activate toggling property page description (SEO)
  togglePropertyPageDescription();

  // Set phone mask with country code
  setPhoneMask();

  document.querySelectorAll('form.validate').forEach(form => {
    form.addEventListener('submit', function (e) {
      if (!validateForm(form)) {
        e.preventDefault();
      }
    });
  });
});

// Window global scope functions.
window.navigatorShare = async (title, text, url) => {
  const shareData = {title, text, url};

  try {
    await navigator.share(shareData);
  } catch (err) {
    // console.error(err);
  }
}


Array.prototype.toggle = function (v) {
  const i = this.indexOf(v);
  if (i === -1) {
    this.push(v);
  } else {
    this.splice(i, 1);
  }
}

window.clamp = (num, min, max) => Math.min(Math.max(num, min), max)

// TODO(frama): Change this to dedicated file.
document.addEventListener('DOMContentLoaded', () => {
  // Video tag events.
  const videoBg = document.getElementById('main-bg-video');
  if (videoBg) {
    videoBg.addEventListener('canplaythrough', () => {
      setTimeout(() => {
        videoBg.classList.add('search-section-video-show');
      }, 500);
    });
    // console.log('readyState', videoBg.readyState);
    // if (videoBg.readyState < 3) {
    //   videoBg.addEventListener('loadeddata', () => {
    //     console.log('readyState', videoBg.readyState);
    //     videoBg.classList.add('search-section-video-show');
    //   });
    // } else {
    //   videoBg.classList.add('search-section-video-show');
    // }
  }
});
